// extracted by mini-css-extract-plugin
export default {"verificationServiceDetailsPoliciesTab":"verification-service-details-policies-tab__verification-service-details-policies-tab__k3kxi"};